<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
export default {
  name: 'nps',
  components: {
    FormWizard,
    TabContent
  },
  data () {
    return {
      dialogVisible: false,
      customerName: 'Jane Jones',
      max: 100,
      value: 1,
      responseModel: '',
      description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem illo, eveniet eius cum adipisci minima eos possimus quas, maxime omnis velit voluptas sit quia minus necessitatibus harum quam, voluptatum dicta!',
      dynamicTags: ['Tømrer', 'Tegltag', 'Loft', 'Isolering', 'Egetræsgulv'],
      inputVisible: false,
      inputValue: ''
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  },
  methods: {
    gotoRegistration () {
      this.$router.push('/klima/registration')
    },
    onComplete () {
      this.dialogVisible = true
      /*  let obj = {
        customClass: 'confirmDialog',
        customIconUrl: '',
        message: '<p class="h3 mt3 regular gibson darkblue line-height-2" style="text-align:left;">Din klima plan er færdig</p>',
        type: 'success',
        customCloseBtnClass: 'primary-button gibson border-none not-rounded h5 regular p2 px3 right',
        customCloseBtnText: 'Luk'
      }
      this.$refs.simplert.openSimplert(obj) */
    },
    isLastStep () {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep
      }
      return false
    },
    isFirstStep () {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isFirstStep
      }
      return false
    },
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    }
  },
  computed: {}
}
</script>
<template>
<div class="animated fadeIn">
    <!-- mobile view -->
    <div class="clearfix fullHeight px0 pt2 pb4 mb2" v-if="showMobile">
      <div class="clearfix mt3 pt1 pb3">
        <p class="h2 center gibson regular primarycolor line-height-3 mb2">Sådan!</p>
        <p class="h4 center regular darkblue gibson line-height-2">Så er opgaven sendt i udbud 🚀</p>
        <div id="nps" class="nps-container center">
          <div class="xs-hide clearfix pt3">
            <div class="col-6 mx-auto">
              <p class="h5 gibson darkblue line-height-3">
                Hvor sandssynligt er det, at du vil anbefale Henttilbud.dk til en ven eller kollega?
              </p>
            </div>
            <div class="col-7 mx-auto mt2 pb4">
              <div class="col-12 flex justify-between">
                <button class="npsbtn p1 darkblue-background white gibson h5 regular pointer detractor" @click="nps(0)">0</button>
                <button class="npsbtn p1 darkblue-background white gibson h5 regular pointer detractor" @click="nps(1)">1</button>
                <button class="npsbtn p1 darkblue-background white gibson h5 regular pointer detractor" @click="nps(2)">2</button>
                <button class="npsbtn p1 darkblue-background white gibson h5 regular pointer detractor" @click="nps(3)">3</button>
                <button class="npsbtn p1 darkblue-background white gibson h5 regular pointer detractor" @click="nps(4)">4</button>
                <button class="npsbtn p1 darkblue-background white gibson h5 regular pointer detractor" @click="nps(5)">5</button>
                <button class="npsbtn p1 darkblue-background white gibson h5 regular pointer detractor" @click="nps(6)">6</button>
                <button class="npsbtn p1 darkblue-background white gibson h5 regular pointer detractor" @click="nps(7)">7</button>
                <button class="npsbtn p1 darkblue-background white gibson h5 regular pointer detractor" @click="nps(8)">8</button>
                <button class="npsbtn p1 darkblue-background white gibson h5 regular pointer detractor" @click="nps(9)">9</button>
                <button class="npsbtn p1 darkblue-background white gibson h5 regular pointer promoter" @click="nps(10)">10</button>
              </div>
              <!-- smileys -->
              <div class="col-12 flex justify-between items-center mt2">
                <div>
                  <img class="fit block lozad" src="static/svg/frown.svg" width="32" height="32" alt="">
                </div>
                <div>
                  <img class="fit block lozad" src="static/svg/smiley.svg" width="32" height="32" alt="">
                </div>
              </div>
              <div class="hide flex mt3 justify-between">
                <span class="darkblue">Slet ikke sandsynligt</span>
                <span class="darkblue">Meget sandsynligt</span>
              </div>
            </div>
          </div>
          <div class="sm-hide md-hide lg-hide clearfix mt3">
            <div class="col-10 mx-auto mb3">
              <p class="h5 gibson regular darkblue line-height-3">
                Hvor sandssynligt er det, at du vil anbefale Henttilbud.dk til en ven eller kollega?
              </p>
            </div>
            <div class="col-12 mx-auto mt2 pb4">
              <div class="col-12 flex justify-between mb1">
                <span class="h6 gibson mediumgrey regular line-height-1 mb1">Slet ikke sandsynligt</span>
                <span class="h6 gibson mediumgrey regular line-height-1 mb1">Meget sandsynligt</span>
              </div>
              <div class="col-12 px0 flex justify-between">
                <button class="npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor" @click="nps(0)">0</button>
                <button class="npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor" @click="nps(1)">1</button>
                <button class="npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor" @click="nps(2)">2</button>
                <button class="npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor" @click="nps(3)">3</button>
                <button class="npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor" @click="nps(4)">4</button>
                <button class="npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor" @click="nps(5)">5</button>
                <button class="npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor" @click="nps(6)">6</button>
                <button class="npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor" @click="nps(7)">7</button>
                <button class="npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor" @click="nps(8)">8</button>
                <button class="npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor" @click="nps(9)">9</button>
                <button class="npsbtn p1 darkblue-background white gibson h6 semi-bold pointer promoter" @click="nps(10)">10</button>
              </div>
              <div class="clearfix mt2">
                <textarea name="" id="" class="fadeFocus p2 h6 line-height-golden regular gibson col-12 lightgrey-background border-none not-rounded mb2" placeholder="Leave your feedback here" style="min-height:100px;"></textarea>
                <button class="action-button p2 mx-auto flex justify-center items-center">
                  <span class="h4 line-height-1 gibson m0 p0">Gem</span>
                  <span class="mx1"><i class="el-icon-right"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="py4"></div>
    </div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<style lang="less">
.el-dialog__footer {
  padding: 0 20px!important;
}
.el-tag {
  border: 0!important;
  border-radius: 0!important;
  height: auto!important;
  padding: 10px 18px!important;
  margin-right: 10px;
}
.el-tag + .el-tag {
  margin-bottom: 10px;
}
.button-new-tag {
  height: 48px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  width:100%;
  background-color: rgba(178, 190, 195, 0.5);
  font-family: 'canada-type-gibson';
  font-size: 17px;
  color: rgba(0, 54, 69, 1.0);
}
.input-new-tag {
  width: 100%;
  vertical-align: bottom;
}
.vue-form-wizard {
  .action-button {
    background-color:#4DCF61!important;
    padding:1.25rem!important;
  }
}
.vue-form-wizard .wizard-header {
  height:0;
  padding:0;
}
.progress {
    background-color: rgba(178, 190, 195, 0.6);
}
.itemSelect {
    input[type="radio"] {
      display: none;
    }
    input[type="radio"] + label {
      display: block;
      background-color: white;
      transition: background-color 0.5s ease;
    }
    .yes {
        color: rgba(77, 207, 85, 1.0);
        border: 2px solid currentColor;
    }
    .no {
        color: rgba(207, 0, 15, 1.0);
        border: 2px solid currentColor;
    }
    input[type="radio"]:checked + label.yes {
      background-color: rgba(77, 207, 85, 1.0);
      transition: background-color 0.5s ease;
      color: white;
      svg {
        fill: white;
      }
    }
    input[type="radio"]:checked + label.no {
      background-color: rgba(207, 0, 15, 1.0);
      transition: background-color 0.5s ease;
      color: white;
      svg {
        fill: white;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// nps.vue?a9445aba